import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import SessionList from './SessionList';
import misc from '../../misc';

export class SessionDetail extends Component {
  renderSessionDetails() {
    const { session } = this.props;
    if (session === null) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="card mb-3">
          <SessionList
            sessions={[session]}
            allClients={this.props.allClients}
            allLocations={this.props.allLocations}
            showDates={true}
          />
        </div>
        <div className="row">
          <div className="col">
            <Link
              to={
                session.clientIds.length < 1
                  ? '/clients'
                  : `/clients/${session.clientIds[0]}`
              }
              className="btn btn-secondary btn-block"
            >
              Client Info
            </Link>
          </div>
          <div className="col">
            <Link
              to={`/sessions/edit/${session.id}`}
              className="btn btn-secondary btn-block"
            >
              Edit Session
            </Link>
          </div>
        </div>
        <div className="mt-3 justify-content-md-center">
          <Link to="#" className="btn btn-lg btn-secondary btn-block">
            Send Reminder
          </Link>
          <Link to="#" className="btn btn-lg btn-secondary btn-block">
            Add Note
          </Link>
          <Link to="#" className="btn btn-lg btn-secondary btn-block">
            Cancel Session
          </Link>
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { isLoading, isError, errorMessage } = this.props;
    return (
      <div className="col-md-9 content">
        {isLoading && <misc.components.LoadingAlert />}
        {isError && <misc.components.Alert message={errorMessage} />}
        {this.renderSessionDetails()}
      </div>
    );
  }
}

SessionDetail.propTypes = {
  session: PropTypes.shape({
    id: PropTypes.string,
    clientIds: PropTypes.array,
    date: PropTypes.date,
    duration: PropTypes.number,
    locationId: PropTypes.string,
    recurring: PropTypes.shape({
      recurs: PropTypes.boolean
    })
  }),
  errorMessage: PropTypes.string,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool
};

SessionDetail.defaultProps = {
  session: null
};

export default SessionDetail;



// WEBPACK FOOTER //
// ./src/modules/sessions/components/SessionDetail.js